import { render } from "./ActionRequiredDialog.vue?vue&type=template&id=31d2f7df&scoped=true"
import script from "./ActionRequiredDialog.vue?vue&type=script&lang=js"
export * from "./ActionRequiredDialog.vue?vue&type=script&lang=js"

import "./ActionRequiredDialog.vue?vue&type=style&index=0&id=31d2f7df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d2f7df"]])

export default __exports__